package com.elan.edubridge.shared.domain.usecase

import com.elan.edubridge.shared.domain.model.TodayDashboard
import com.elan.edubridge.shared.domain.repository.EduConnectRepository

/**
 * v4 스태프 대시보드 상단(통계 4타일 + 오늘 수업 테이블).
 *
 * 두 조회를 한 read model로 합치는 이유는 화면이 둘을 항상 함께 그리고,
 * 통계가 어느 `serviceDate`의 것인지가 수업 목록과 어긋나면 안 되기 때문이다.
 * 기준 날짜는 통계 응답의 것을 따른다 — 서버가 학원 timeZone으로 해석한 값이 정답이다(R12).
 */
class GetTodayDashboardUseCase(
    private val repository: EduConnectRepository,
) {
    /** @param serviceDate null이면 학원 timeZone 기준 오늘. */
    suspend operator fun invoke(academyId: String, serviceDate: String?): TodayDashboard {
        val summary = repository.attendanceSummary(academyId, serviceDate)
        return TodayDashboard(
            academyId = academyId,
            serviceDate = summary.serviceDate,
            summary = summary,
            classes = repository.todayClasses(academyId, summary.serviceDate),
        )
    }
}
